export default __webpack_public_path__ + "static/media/guia-5-3.23581087.svg";